import * as yup from 'yup';
import { MAX_VALID, MIN_VALID, REQUIRE_VALID, mobilePhoneSchema } from '../../data';

export interface IEditProfileForm {
  avatar: any;
  firstName: string;
  lastName: string;
  email: string;
  postalCode: string;
  mobilePhone: string;
  gender: string;
  language: string;
  code?: string;
  birthday?: string;
}

export const EDIT_PROFILE_DEFAULT_VALUES = {
  avatar: '',
  birthday: '',
  firstName: '',
  lastName: '',
  email: '',
  postalCode: '',
  mobilePhone: '',
  gender: '',
};

export const EDIT_PROFILE_VALIDATION = yup.object({
  birthday: yup.date().required(REQUIRE_VALID),
  firstName: yup.string().required(REQUIRE_VALID).min(2, MIN_VALID(2)).max(100, MAX_VALID(100)),
  lastName: yup.string().required(REQUIRE_VALID).min(2, MIN_VALID(2)).max(100, MAX_VALID(100)),
  postalCode: yup.string().required(REQUIRE_VALID).min(4, MIN_VALID(4)).max(50, MAX_VALID(50)),
  gender: yup.string().required(REQUIRE_VALID),
  mobilePhone: mobilePhoneSchema,
  avatar: yup
    .mixed()
    .test({
      message: 'validation.error.file.too.big',
      test: (value: any) => {
        return typeof value === 'string' || !value ? true : value?.size < 6_000_000;
      },
    })
    .nullable(),
});
